import { Injectable } from '@angular/core';
import { Platform, App, ToastController } from 'ionic-angular';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { throwError } from 'rxjs';
import { timeout, catchError } from 'rxjs/operators';

@Injectable()
export class AIServices {

  openai_api_path: String = 'https://api.openai.com/v1/';
  headers: HttpHeaders = new HttpHeaders({ Authorization: 'Bearer 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' });
  headers_deepseek: HttpHeaders = new HttpHeaders({ Authorization: 'Bearer sk-6bb6c35a18a94470b224ddfa53590c8a' });
  // For Image Generation
  model_img: string = 'dall-e-3';

  // For LLMs (Language Models)
  model_llm_gpt4_turbo: string = 'gpt-4-turbo';
  model_llm_gpt4_1106: string = 'gpt-4-1106-preview';
  model_llm_gpt4o: string = 'gpt-4o';
  model_llm_gpt4_5_prev: string = 'gpt-4.5-preview';

  constructor(public app: App,
    public platform: Platform,
    private http: HttpClient,
    public toastCtrl: ToastController,
    public translate: TranslateService) {
  }

  async openAIGenerateImage(prompt) {
    //prepare body
    var body = {
      prompt: prompt,
      model: this.model_img,
      n: 1,
      size: '1024x1024',
      quality: 'hd'
    };
    //call api
    return await this.http.post(this.openai_api_path + 'images/generations',
      body,
      {
        headers: this.headers
      }).toPromise();
  }

  async openAIGenerateText(response_format, messages, _timeout) {
    //prepare body
    const body = {
      model: this.model_llm_gpt4_5_prev,
      response_format: response_format,
      messages: messages,
      max_tokens: 6000
    }
    //call api
    var response = await this.http.post(this.openai_api_path + 'chat/completions',
      body,
      {
        headers: this.headers
      }).pipe(
        timeout(_timeout),
        catchError(error => {
          return throwError(error);
        })
      ).toPromise();
    return response;
  }

  async deepseekOpenAIGenerateText(response_format, messages) {
    // Prepare body for DeepSeek API
    const body = {
      model: "deepseek-chat", //deepseek-chat" - deepseek-reasoner
      messages: messages,
      temperature: 1.0,
      max_tokens: 6000,
      top_p: 0.8,
      frequency_penalty: 0.1,
      presence_penalty: 0.1,
      stream: false
    };

    // Add response_format only if it's provided
    if (response_format) {
      body['response_format'] = response_format;
    }

    // DeepSeek API endpoint
    const deepseekApiUrl = 'https://api.deepseek.com/chat/completions';
    
    try {
      // Call API with error handling
      const response = await this.http.post(deepseekApiUrl, body, {
        headers: this.headers_deepseek
      }).pipe(
        catchError(error => {          
          // Handle specific error cases
          if (error && error.status === 401) {
            throw new Error('Authentication failed. Please check your API key.');
          } else if (error && error.status === 429) {
            throw new Error('Rate limit exceeded. Please try again later.');
          } else if (error && error.status === 400) {
            const errorMessage = error.error && error.error.message ? error.error.message : 'Unknown error';
            throw new Error(`Bad request: ${errorMessage}`);
          } else if (error && error.name === 'TimeoutError') {
            throw new Error('Request timed out. Please try again.');
          }
          
          const errorMessage = error && error.message ? error.message : 'Unknown error';
          throw new Error(`API call failed: ${errorMessage}`);
        })
      ).toPromise();
      return response;
    } catch (error) {
      const errorMessage = error && error.message ? error.message : 'Unknown error';
      throw new Error(`DeepSeek API call failed: ${errorMessage}`);
    }
  }

  async openAIGeneratePromptForDallE(input_text) {
    var messages = [
      { "role": "system", "content": "Eres un experto en crear prompts para DALL-E. Por favor, genera solo el texto del prompt en inglés, sin añadir ningún encabezado, introducción o comentario adicional." },
      { "role": "user", "content": "A partir de este texto: " + input_text + ", genera un prompt detallado en inglés para crear una imagen en DALL-E. El prompt debe ser lo suficientemente específico para que el modelo pueda entender y generar la imagen deseada sin ninguna ambigüedad. No añadas la frase 'Prompt para DALL-E:' ni ninguna otra introducción, solo el contenido del prompt." }
    ];

    // prepare body
    const body = {
      model: this.model_llm_gpt4o,
      messages: messages
    };

    // call api
    var response = await this.http.post(this.openai_api_path + 'chat/completions',
      body,
      {
        headers: this.headers
      }).toPromise();
    return response;
  }

  async openAIGenerateSuggestedPrice(response_format, messages, _timeout) {
    //prepare body
    const body = {
      model: this.model_llm_gpt4o,
      response_format: response_format,
      messages: messages
    }
    //call api
    var response = await this.http.post(this.openai_api_path + 'chat/completions',
      body,
      {
        headers: this.headers
      }).pipe(
        timeout(_timeout),
        catchError(error => {
          return throwError(error);
        })
      ).toPromise();
    return response;
  }
}


// WEBPACK FOOTER //
// ./src/pages/services/aiServices.ts